/**
 * SelectionTool.tsx
 * 
 * 职责：
 * 1. 提供选择工具的用户界面组件
 * 2. 展示选择工具的使用说明和快捷键指南
 * 3. 条件渲染工具面板，仅在选择工具激活时显示
 * 4. 提供用户友好的选择操作指导
 * 5. 呈现选择相关的快捷键和操作提示
 */

import React, { useEffect, useState } from 'react';

interface SelectionToolProps {
  isActive: boolean;
  position?: { top: number, left: number };
}

const SelectionTool: React.FC<SelectionToolProps> = ({
  isActive,
  position
}) => {
  // 添加动画状态
  const [isVisible, setIsVisible] = useState(false);
  
  // 监听isActive变化，添加延迟显示效果
  useEffect(() => {
    if (isActive) {
      // 延迟一帧显示，确保CSS过渡生效
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isActive]);
  
  // 如果工具未激活，不显示面板
  if (!isActive) {
    return null;
  }
  
  // 计算面板位置
  const panelStyle = position ? {
    top: `${position.top}px`,
    left: `${position.left}px`,
  } : {
    top: '60px',
    left: '80px',
  };
  
  return (
    <div className="selection-tool-panel" style={{
      position: 'absolute',
      ...panelStyle,
      backgroundColor: '#f5f5f5',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '10px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 9000,
      fontSize: '12px',
      color: '#666',
      maxWidth: '200px',
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(-10px)',
      transition: 'opacity 0.3s ease, transform 0.3s ease',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none'
    }}>
      <h4 style={{ marginBottom: '8px', fontSize: '14px', color: '#333' }}>选择工具</h4>
      
      <div className="selection-instructions">
        <ul style={{ paddingLeft: '15px', lineHeight: '1.5' }}>
          <li>拖动鼠标框选内容</li>
          <li>按住Shift键进行多选</li>
          <li>使用Delete键删除选中内容</li>
          <li>Ctrl+C复制选中内容</li>
          <li>Ctrl+V粘贴复制的内容</li>
          <li>右键点击显示上下文菜单</li>
        </ul>
      </div>
    </div>
  );
};

export default SelectionTool; 